/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssistantConversationsGet200ResponseConversationsInner } from './AssistantConversationsGet200ResponseConversationsInner';
import {
    AssistantConversationsGet200ResponseConversationsInnerFromJSON,
    AssistantConversationsGet200ResponseConversationsInnerFromJSONTyped,
    AssistantConversationsGet200ResponseConversationsInnerToJSON,
    AssistantConversationsGet200ResponseConversationsInnerToJSONTyped,
} from './AssistantConversationsGet200ResponseConversationsInner';

/**
 * 
 * @export
 * @interface AssistantConversationsGet200Response
 */
export interface AssistantConversationsGet200Response {
    /**
     * 
     * @type {Array<AssistantConversationsGet200ResponseConversationsInner>}
     * @memberof AssistantConversationsGet200Response
     */
    conversations: Array<AssistantConversationsGet200ResponseConversationsInner>;
}

/**
 * Check if a given object implements the AssistantConversationsGet200Response interface.
 */
export function instanceOfAssistantConversationsGet200Response(value: object): value is AssistantConversationsGet200Response {
    if (!('conversations' in value) || value['conversations'] === undefined) return false;
    return true;
}

export function AssistantConversationsGet200ResponseFromJSON(json: any): AssistantConversationsGet200Response {
    return AssistantConversationsGet200ResponseFromJSONTyped(json, false);
}

export function AssistantConversationsGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistantConversationsGet200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'conversations': ((json['conversations'] as Array<any>).map(AssistantConversationsGet200ResponseConversationsInnerFromJSON)),
    };
}

export function AssistantConversationsGet200ResponseToJSON(json: any): AssistantConversationsGet200Response {
    return AssistantConversationsGet200ResponseToJSONTyped(json, false);
}

export function AssistantConversationsGet200ResponseToJSONTyped(value?: AssistantConversationsGet200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'conversations': ((value['conversations'] as Array<any>).map(AssistantConversationsGet200ResponseConversationsInnerToJSON)),
    };
}

